import type { BaseDocument } from '../mongo/base-document.interface';
import type { BuiltInRoleKey } from './built-in';

export const ROLE_SCOPE = {
  CARRIER: 'carrier',
  SITE: 'site',
  SPACE: 'space',
  TENANT: 'tenant',
} as const;

export type RoleScope = (typeof ROLE_SCOPE)[keyof typeof ROLE_SCOPE];

export interface UserScope {
  id: string;
  level: RoleScope;
}

export interface RoleFunctions {
  isDriver?: boolean;
}

export const ROLE_REQUIRED_SCOPE: Record<BuiltInRoleKey, RoleScope | null> = {
  ACCOUNT_MANAGER: null,
  CARRIER: ROLE_SCOPE.CARRIER,
  // A driver's carrier association lives in driverAttributes.carrierId, not in a scope entry.
  DRIVER: null,
  SITE_MANAGER: ROLE_SCOPE.SITE,
  SITE_OPERATOR: ROLE_SCOPE.SITE,
  SPACE_ADMIN: ROLE_SCOPE.SPACE,
  TENANT_ADMIN: ROLE_SCOPE.TENANT,
};

export interface Role extends BaseDocument {
  functions?: RoleFunctions;
  key: string;
  permissions: string[];
}
